import ActionFs from './action.fs';
import ActionWeb from './action.web';
import ActionYun from './action.yun';
import { CONFIRM_TYPE, FILE, FILEPATH, RENAME, SAVED, SYNC_PROJECTS, UPLOAD_PROJECT, SEARCH,
    UPDATE_PRE_PROJECT_DATA_STRING, UPDATE_PROJECT_LOADED_STATE } from './actionTypes';
import { getFileName } from '../../util';
import MscratchService from '../../services/mscratch';
import _ from 'lodash';
import CONSTANT from '../../constant';

class Action {

    static saved(data) {
        let payload = {};
        if (_.isObject(data)) {
            if (_.has(data, 'filePath')) {
                if (!_.has(data, 'name') || !data.name) {
                    data.name = getFileName(data.filePath);
                }
            }
            payload = data;
        } else {
            payload = { saved: data };
        }
        return {
            type: SAVED,
            payload
        };
    }

    static filePath(filePath) {
        return {
            type: FILEPATH,
            payload: { filePath }
        };
    }

    static file(file) {
        return {
            type: FILE,
            payload: { file }
        };
    }

    static rename(data) {
        let payload = {};
        if (_.isObject(data)) {
            if (_.has(data, 'filePath')) {
                if (!_.has(data, 'name') || !data.name) {
                    data.name = getFileName(data.filePath);
                }
            }
        }
        payload = data;
        return {
            type: RENAME,
            payload
        };
    }

    static confirmType(type) {
        return {
            type: CONFIRM_TYPE,
            payload: { confirmSaveType: type }
        };
    }

    static SaveMsg(store, saveStatus) {
        let obj = {
            type: SAVED,
            payload: { saveStatus: saveStatus }
        };
        if (saveStatus === CONSTANT.PROJECT_SAVE_STATUS.SUCCESS || saveStatus === CONSTANT.PROJECT_SAVE_STATUS.FAILURE) {
            setTimeout(() => {
                obj.payload.saveStatus = '';
                store.dispatch(obj);
            }, 3000);
        }
        store.dispatch(obj);
    }

    static syncMsg(store, syncLabel) {
        let obj = {
            type: SYNC_PROJECTS,
            payload: { syncLabel }
        };
        if (syncLabel === CONSTANT.PROJECT_SYNC_STATUS['SUCCESS']) {
            setTimeout(() => {
                obj.payload.syncLabel = '';
                store.dispatch(obj);
            }, 2000);
        }
        store.dispatch(obj);
    }

    static Upload(payload) {
        return {
            type: UPLOAD_PROJECT,
            payload: payload
        };
    }

    static search(searchText) {
        return {
            type: SEARCH,
            payload: { searchText }
        };
    }

    static updatePreProject(data) {
        let preProjectData = data || MscratchService.getProjectJsonString();
        console.log('--saved--');
        return {
            type: UPDATE_PRE_PROJECT_DATA_STRING,
            payload: {
                preProjectData
            }
        };
    }

    static updateProjectLoadedState(data) {
        return {
            type: UPDATE_PROJECT_LOADED_STATE,
            payload: {
                isLoaded: data
            }
        };
    }

    static Strategy(store, target) {
        switch (target) {
            case 'yun':
                return new ActionYun(store);
            case 'web':
                return new ActionWeb(store);
            case 'fs':
            default:
                return new ActionFs(store);
        }
    }
}

export default Action;